import { callAlertWeb, showKycRequiredPopupWeb } from 'common/appInterface';
import { KYC_REQUIRED_POPUP_MIN_VERSION } from '../constants/Card';

/**
 * apply/info 실패 응답(code !== "00") 처리.
 * KYC 미인증(APPL02.kycApproved)이고 앱버전이 기준 이상이면 네이티브 KYC 팝업을 띄우고,
 * 그 외에는 기존과 동일하게 서버 메시지를 알럿으로 띄운다.
 */
export const handleApplyInfoError = (code: string, message: string, apiVersion: string) => {
  if (code === "APPL02.kycApproved" && Number(apiVersion) >= KYC_REQUIRED_POPUP_MIN_VERSION) {
    showKycRequiredPopupWeb();
    return;
  }

  callAlertWeb("ERROR", code, message);
};
